import React, { useState, useEffect, useRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import saleImg from "../../../assets/images/saleImg.png";
import Modal from "react-bootstrap/Modal";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { RiDeleteBinLine } from "react-icons/ri";
import { axiosInstance } from "../../../axiosInstance";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import placeholderImg from "../../../assets/images/previewPlaceholder.png";
import Pagination from "@mui/material/Pagination";
import { IoClose } from "react-icons/io5";
import { GoSearch } from "react-icons/go";
import { FaArrowLeftLong } from "react-icons/fa6";

export const StateSalesProduct = () => {
  const location = useLocation();
  // const orderId = location.state?.orderId ?? null;
  const [orderId, setOrderId] = useState(location.state?.orderId ?? null);
  console.log("orderId", orderId);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  // const [activeMenu, setactiveMenu] = useState("allProducts");

  // function handleSelectMenu(menu) {
  //   setactiveMenu(menu);
  // }

  // proceed modal
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // cancel order modal
  const [cancelshow, setCancelShow] = useState(false);

  const handleCancelClose = () => setCancelShow(false);
  const handleCancelShow = () => setCancelShow(true);

  const [productsData, setProductsData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  // pagination state
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const itemsPerPage = 5;

  const handleChange = (event, value) => {
    setPage(value);
  };

  async function LoadProducts() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: page + 1,
          category: selectedCategory || "",
          search: searchQuery || "",
          // product_code:
          // page_size: itemsPerPage,
        },
      };
      const response = await axiosInstance.get(
        "/inventory/distributor/products/",
        config,
      );
      if (response.data.status === "Success" || response.status === 200) {
        setProductsData(response.data.data.results);
        setTotalPages(Math.ceil(response.data.data.count / itemsPerPage));
        console.log("Fetched products list successfully");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch products list",
      );
      console.log("Failed to fetch products list");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    LoadProducts();
  }, [page]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (page !== 0) {
        setPage(0);
      } else {
        LoadProducts();
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchQuery, selectedCategory]);

  function handleReset() {
    setSearchQuery("");
  }
  function handleClearFilters() {
    setSearchQuery("");
    setSelectedCategory("");
  }

  const [categoryDropdown, setCategoryDropdown] = useState([]);

  async function LoadCategories() {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/inventory/category/");
      if (response.data.message === "Success" || response.status === 200) {
        setCategoryDropdown(response.data.data);
        console.log("Fetched categories successfully!");
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to fetch categories");
      console.log("Failed to fetch categories");
    }
  }
  useEffect(() => {
    LoadCategories();
  }, []);

  const handleAddClick = (product_id, newQty = 1) => {
    AddProductToCart(product_id, newQty);
  };
  const handleDeleteClick = (product_id, newQty = 0) => {
    AddProductToCart(product_id, newQty);
  };
  const increment = (product_id, currentQty) => {
    AddProductToCart(product_id, currentQty + 1);
  };

  const decrement = (product_id, currentQty) => {
    AddProductToCart(product_id, currentQty - 1);
  };
  const debounceRef = useRef({});
  const handleQtyChange = (product_id, value) => {
    // Update UI first
    const updatedCart = { ...cartData };
    updatedCart.items = updatedCart.items.map((item) =>
      item.product_id === product_id ? { ...item, qty: value } : item,
    );
    setCardData(updatedCart);

    // Debounce API
    if (debounceRef.current[product_id]) {
      clearTimeout(debounceRef.current[product_id]);
    }

    debounceRef.current[product_id] = setTimeout(() => {
      const qty = Number(value);
      if (!value || isNaN(qty) || qty < 0) return;

      AddProductToCart(product_id, qty);
    }, 500);
  };
  async function AddProductToCart(product_id, newQty) {
    try {
      setLoading(true);

      const payload = {
        order_id: orderId || null,
        products: [
          {
            product_id: product_id,
            qty: newQty,
          },
        ],
      };
      const response = await axiosInstance.post(
        "/pos/distributor/cart/",
        payload,
      );
      if (response.data.status) {
        // toast.success(response.data.message || "Product added to cart");
        console.log("Product added to cart");
        setOrderId(response.data.order_id);
        if (response.data?.order_id) {
          LoadCartDetails(response.data?.order_id);
        }
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to add product to cart",
      );
      console.log("Failed to add product to cart");
    } finally {
      setLoading(false);
    }
  }
  const [cartData, setCardData] = useState({});
  async function LoadCartDetails(orderId) {
    try {
      const response = await axiosInstance.get(
        `/pos/distributor/draft-detail/${orderId}/`,
      );
      if (response.data.status === "Success" || response.status === 200) {
        setCardData(response.data.order);
        console.log("Cart Details fetched succcessfully!");
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to get cart details");
      console.log("Failed to get cart details");
    }
  }
  useEffect(() => {
    if (orderId) {
      LoadCartDetails(orderId);
    }
  }, [orderId]);

  const [customerName, setCustomerName] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [district, setDistrict] = useState("");
  const [state, setState] = useState("");
  const [pincode, setPincode] = useState("");
  const [statecode, setStatecode] = useState(null);
  const [gstin, setGstin] = useState("");
  const [pan, setPan] = useState("");

  const [paymentType, setPaymentType] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [errors, setErrors] = useState({});
  async function handleConfirmPayment() {
    try {
      const newErrors = {};

      if (!customerName?.trim()) {
        newErrors.customerName = "Customer name is required";
      }

      if (!/^\d{10}$/.test(contactNumber)) {
        newErrors.contactNumber = "Enter valid 10-digit number";
      }
      if (email && !email.includes("@")) {
        newErrors.email = "Invalid email";
      }

      if (!paymentType) {
        newErrors.paymentType = "Payment type is required";
      }

      if (!paymentMode) {
        newErrors.paymentMode = "Payment mode is required";
      }

      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return; //  stop API call
      }
      setLoading(true);
      const payload = {
        order_id: orderId,
        payment_type: paymentType,
        payment_mode: paymentMode,
        gst_amount: cartData?.grand_total, // getting in get call
        customer_name: customerName,
        phone_number: contactNumber,
        email: email,
        address: address,
        city: city,
        district: district,
        state: state,
        pincode: pincode,
        state_code: statecode,
        gstin: gstin,
        pan_number: pan,
      };
      const response = await axiosInstance.post(
        "/pos/distributor/submit-pos/",
        payload,
      );
      if (response.data.status === "Success" || response.status === 200) {
        toast.success(response.data.message || "Order Placed Successfully");
        handleClose();
        setTimeout(() => {
          navigate("/state-invoice-view", {
            state: { Id: response.data.invoice_id },
          });
        }, 2000);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to place order");
      console.log("Failed to place order");
    } finally {
      setLoading(false);
    }
  }
  async function handleCancelOrder() {
    try {
      setLoading(true);
      const response = await axiosInstance.delete(
        `/pos/distributor/cart-cancel-order/${orderId}/`,
      );
      if (response.data.status === "Success" || response.status === 200) {
        setTimeout(() => {
          navigate("/state-sales");
        }, 2000);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to cancel order");
      console.log("Failed to cancel order");
    }
  }

  const getCartItemByProductId = (productId) => {
    return cartData?.items?.find((item) => item.product_id === productId);
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="salesContainer">
        <div className="container">
          <div className="dashboardTitleContainer">
            <div>
              <div className="inventoryTitle">
                {" "}
                <span className="me-1">
                  <Link
                    to="/state-sales"
                    style={{ color: "var(--color-font-primary)" }}
                  >
                    <FaArrowLeftLong />
                  </Link>
                </span>{" "}
                Sales (POS)
              </div>
              <div className="inventorySubtitle">
                Create new sales bills for walk-in customers or retail buyers.
              </div>
            </div>
          </div>

          {/* search  */}
          {/* <div className="searchMainContainer">
            <div className="searchSubContainer">
              <div>
                <input type="text" placeholder="Search" />
              </div>

              <div>
                <div className="dropdownTitle">Product Category</div>
                <Dropdown>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {categoryToggle}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item>All</Dropdown.Item>
                    {categories.map((cat) => (
                      <Dropdown.Item
                        onClick={() => setCategoryToggle(cat.name)}
                      >
                        {cat.name}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            <div className="addButtonContainer">{""}</div>
          </div> */}
          <div className="searchMainContainer">
            <div className="searchSubContainer">
              <div className="searchGrid">
                <div>
                  <input
                    type="text"
                    placeholder="Search by Product Name"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>
                <div style={{ display: "flex", gap: "5px" }}>
                  <div>
                    <GoSearch className="searchIcon" />
                  </div>
                  <div className="btnRestSearch">
                    <button onClick={handleReset}>Reset</button>
                  </div>
                </div>
              </div>
              <div>
                <div className="dropdownTitle">Product Category</div>
                <Dropdown>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {selectedCategory || "All"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => setSelectedCategory("")}>
                      All
                    </Dropdown.Item>
                    {categoryDropdown?.map((cat) => (
                      <Dropdown.Item
                        onClick={() => setSelectedCategory(cat.name)}
                      >
                        {cat.name}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div></div>
            </div>
          </div>
          {(searchQuery || selectedCategory) && (
            <div className="filterResultsContainer">
              <div>
                <span style={{ color: "var(--color-font-primary)" }}>
                  Showing Results Of : &nbsp;
                </span>
                {searchQuery && (
                  <>
                    {" "}
                    &nbsp; <strong>Search:</strong> {searchQuery}{" "}
                  </>
                )}
                {selectedCategory && (
                  <>
                    {" "}
                    &nbsp; <strong>Category:</strong> {selectedCategory}{" "}
                  </>
                )}
              </div>
              <div
                style={{
                  cursor: "pointer",
                  color: "var(--color-font-primary)",
                }}
                onClick={handleClearFilters}
              >
                {" "}
                <span className="me-1">
                  <IoClose />
                </span>
                Clear Filters
              </div>
            </div>
          )}
          {/* tabs */}
          <div className="salesMenuContainer">
            <div
              onClick={() => setSelectedCategory("")}
              className={`salesMenu ${selectedCategory === "" ? "active" : ""}`}
            >
              All
            </div>
            {categoryDropdown.map((cat) => (
              <div
                onClick={() => setSelectedCategory(cat.name)}
                className={`salesMenu ${
                  selectedCategory === cat.name ? "active" : ""
                }`}
              >
                {cat.name}
              </div>
            ))}
          </div>

          <div className="salesSubContainer">
            {/* cards  */}

            <div>
              <div className="salesCardGrid">
                {productsData?.length > 0 ? (
                  productsData?.map((product) => {
                    // const qty = qtyMap[product.id] || 0;

                    return (
                      <div className="salesCard" key={product.id}>
                        <div className="salesCardContent">
                          <div>
                            <img src={product.product_image ?? saleImg} />
                          </div>

                          <div className="salesCardTitle">
                            {product.product_name}
                          </div>
                          <div>
                            <span className="salesCardPrice">
                              ₹ {product.retail_selling_price}{" "}
                            </span>
                            {/* <span className="salesCardTitle">
                            per {product.uom}
                          </span> */}
                          </div>
                          <div className="salesCardTitle">
                            Current Stock : {product.current_stock}
                          </div>
                          <div className="salesCardTitle">
                            Package Size : {product.package_size}
                          </div>
                        </div>

                        {/* <div className="salesCardBtnContainer">
                     
                          {product.current_stock <= 0 ? (
                            <button className="salesCardBtnAdd inactive">
                              Out Of Stock
                            </button>
                          ) : (
                            <button
                              className="salesCardBtnAdd"
                              onClick={() => handleAddClick(product.id)}
                            >
                              Add
                            </button>
                          )}
                        </div> */}
                        <div className="salesCardBtnContainer">
                          {(() => {
                            const cartItem = getCartItemByProductId(product.id);

                            if (product.current_stock <= 0) {
                              return (
                                <button
                                  className="salesCardBtnAdd inactive"
                                  disabled
                                >
                                  Out Of Stock
                                </button>
                              );
                            }

                            // product exist in cart
                            if (cartItem) {
                              return (
                                <div className="salesCardBtnCount">
                                  <button
                                    onClick={() =>
                                      decrement(
                                        cartItem.product_id,
                                        cartItem.qty,
                                      )
                                    }
                                  >
                                    -
                                  </button>

                                  <span>{cartItem.qty}</span>

                                  <button
                                    onClick={() =>
                                      increment(
                                        cartItem.product_id,
                                        cartItem.qty,
                                      )
                                    }
                                    disabled={
                                      cartItem.qty >= product.current_stock
                                    }
                                  >
                                    +
                                  </button>
                                </div>
                              );
                            }

                            // product not in cart
                            return (
                              <button
                                className="salesCardBtnAdd"
                                onClick={() => handleAddClick(product.id)}
                              >
                                Add
                              </button>
                            );
                          })()}
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div style={{ fontSize: "14px", fontWeight: "500" }}>
                    Data not available
                  </div>
                )}
              </div>

              <div className="paginationContainer">
                <Stack spacing={2} justifyContent="center" alignItems="center">
                  <Pagination
                    count={totalPages}
                    page={page}
                    onChange={handleChange}
                    color="success"
                  />
                </Stack>
              </div>
            </div>

            {/* cart summary*/}
            <div className="cartSummaryContainer">
              <div className="cartSummaryId">
                Order ID : {cartData?.order_id}
              </div>
              <div className="cartDate">
                <div>{cartData?.order_date}</div>
                {/* <div>10:40 AM</div> */}
              </div>

              <div className="cartSummaryText">Cart Summary</div>
              {cartData?.items?.length > 0 ? (
                cartData?.items.map((item) => {
                  // const qty = qtyMap[item.product_id] || 0;
                  return (
                    <div className="cartProduct">
                      <div>
                        <img src={item.product_image || placeholderImg} />
                      </div>
                      <div className="cartProductContent">
                        <div>{item.product_name}</div>
                        <div>₹ {item.total}</div>
                      </div>
                      <div>
                        <div
                          style={{
                            color: "red",
                            fontSize: "18px",
                            marginBottom: "5px",
                            cursor: "pointer",
                          }}
                          onClick={() => handleDeleteClick(item.product_id)}
                        >
                          <RiDeleteBinLine />
                        </div>

                        {/* <div className="cartCount">
                        <button onClick={decrement}>-</button>
                        <span>{count}</span>
                        <button onClick={increment}>+</button>
                      </div> */}
                        <div className="cartCount">
                          <button
                            onClick={() => decrement(item.product_id, item.qty)}
                          >
                            -
                          </button>

                          {/* <span>{item.qty}</span> */}
                          <span>
                            <input
                              type="number"
                              min="0"
                              value={item.qty}
                              onChange={(e) =>
                                handleQtyChange(item.product_id, e.target.value)
                              }
                              className="qtyInput"
                            />
                          </span>

                          <button
                            onClick={() => increment(item.product_id, item.qty)}
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    marginBottom: "20px",
                  }}
                >
                  Data not available
                </div>
              )}

              <div className="cartPriceContainer">
                <div className="cartSubtotal">
                  <div>Sub Total</div>
                  <div>₹ {cartData?.total_amount}</div>
                </div>
                <div className="cartSubtotal">
                  <div>GST</div>
                  <div>₹ {cartData?.gst_amount}</div>
                </div>
                <div className="cartTotal">
                  <div>Grand Total</div>
                  <div>₹ {cartData?.grand_total}</div>
                </div>
                <div className="cartBtnContainer">
                  <div className="cartBtnCancel">
                    <button type="button" onClick={handleCancelShow}>
                      Cancel Order
                    </button>
                  </div>
                  <div className="cartBtnProceed">
                    <button onClick={handleShow}>Proceed to Payment</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* proceed to payment modal  */}
        <Modal
          show={show}
          onHide={handleClose}
          centered
          className="paymentModal"
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Complete Payment</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="paymentModalGrid">
              <div className="paymentModalInput">
                <label>
                  Customer Name <span className="text-danger">*</span>
                </label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Customer Name"
                    onChange={(e) => {
                      setCustomerName(e.target.value);
                      setErrors((prev) => ({ ...prev, customerName: "" }));
                    }}
                  />
                </div>
                {errors.customerName && (
                  <div style={{ fontSize: "12px", color: "red" }}>
                    {errors.customerName}
                  </div>
                )}
              </div>
              <div className="paymentModalInput">
                <label>
                  Contact Number <span className="text-danger">*</span>
                </label>
                <div>
                  <input
                    type="number"
                    maxLength={10}
                    placeholder="Enter Contact Number"
                    onChange={(e) => {
                      setContactNumber(e.target.value);
                      setErrors((prev) => ({ ...prev, contactNumber: "" }));
                    }}
                  />
                </div>
                {errors.contactNumber && (
                  <div style={{ fontSize: "12px", color: "red" }}>
                    {errors.contactNumber}
                  </div>
                )}
              </div>
              <div className="paymentModalInput">
                <label>Email</label>
                <div>
                  <input
                    type="email"
                    placeholder="Enter Email"
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setErrors((prev) => ({ ...prev, email: "" }));
                    }}
                  />
                </div>
                {errors.email && (
                  <div style={{ fontSize: "12px", color: "red" }}>
                    {errors.email}
                  </div>
                )}
              </div>

              <div className="paymentModalInput">
                <label>Address</label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Address"
                    onChange={(e) => {
                      setAddress(e.target.value);
                      setErrors((prev) => ({ ...prev, address: "" }));
                    }}
                  />
                </div>
              </div>
              <div className="paymentModalInput">
                <label>City</label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter City"
                    onChange={(e) => {
                      setCity(e.target.value);
                      setErrors((prev) => ({ ...prev, city: "" }));
                    }}
                  />
                </div>
              </div>
              <div className="paymentModalInput">
                <label>District</label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter District"
                    onChange={(e) => {
                      setDistrict(e.target.value);
                      setErrors((prev) => ({ ...prev, district: "" }));
                    }}
                  />
                </div>
              </div>
              <div className="paymentModalInput">
                <label>State</label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter State"
                    onChange={(e) => {
                      setState(e.target.value);
                      setErrors((prev) => ({ ...prev, state: "" }));
                    }}
                  />
                </div>
              </div>
              <div className="paymentModalInput">
                <label>Pin Code</label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Pincode"
                    onChange={(e) => {
                      setPincode(e.target.value);
                      setErrors((prev) => ({ ...prev, pincode: "" }));
                    }}
                  />
                </div>
              </div>
              <div className="paymentModalInput">
                <label>State Code</label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter State Code"
                    onChange={(e) => {
                      setStatecode(e.target.value);
                      setErrors((prev) => ({ ...prev, statecode: "" }));
                    }}
                  />
                </div>
              </div>
              <div className="paymentModalInput">
                <label>GSTIN</label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter GSTIN"
                    onChange={(e) => {
                      setGstin(e.target.value);
                      setErrors((prev) => ({ ...prev, gstin: "" }));
                    }}
                  />
                </div>
              </div>

              <div className="paymentModalInput">
                <label>
                  Payment Type <span className="text-danger">*</span>
                </label>
                <div>
                  <select
                    onChange={(e) => {
                      setPaymentType(e.target.value);
                      setErrors((prev) => ({ ...prev, paymentType: "" }));
                    }}
                  >
                    <option value="" selected disabled>
                      Select
                    </option>
                    <option value="debit">Debit</option>
                    <option value="credit">Credit</option>
                  </select>
                </div>
                {errors.paymentType && (
                  <div style={{ fontSize: "12px", color: "red" }}>
                    {errors.paymentType}
                  </div>
                )}
              </div>
              <div className="paymentModalInput">
                <label>
                  Payment Mode <span className="text-danger">*</span>
                </label>
                <div>
                  <select
                    onChange={(e) => {
                      setPaymentMode(e.target.value);
                      setErrors((prev) => ({ ...prev, paymentMode: "" }));
                    }}
                  >
                    <option value="" selected disabled>
                      Select
                    </option>
                    <option value="upi">UPI</option>
                    <option value="cash">Cash</option>
                  </select>
                </div>
                {errors.paymentMode && (
                  <div style={{ fontSize: "12px", color: "red" }}>
                    {errors.paymentMode}
                  </div>
                )}
              </div>
              <div className="paymentModalInput">
                <label>Pan Number</label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter PAN"
                    onChange={(e) => {
                      setPan(e.target.value);
                      setErrors((prev) => ({ ...prev, pan: "" }));
                    }}
                  />
                </div>
              </div>
              {/* <div className="paymentModalInput">
                <label>Agent Referral Code</label>
                <div>
                  <input
                    type="text"
                    placeholder="Enter Agent Referral Code"
                    onChange={(e) => {
                      setStatecode(e.target.value);
                      setErrors((prev) => ({ ...prev, statecode: "" }));
                    }}
                  />
                </div>
              </div> */}
            </div>
            <div className="cartSubtotal">
              <div>Sub Total</div>
              <div>{cartData?.total_amount}</div>
            </div>
            <div className="cartSubtotal">
              <div>GST</div>
              <div>₹ {cartData?.gst_amount}</div>
            </div>
            <div className="cartTotal">
              <div>Grand Total</div>
              <div>₹ {cartData?.grand_total}</div>
            </div>
            <div className="paymentBtnContainer">
              <div className="paymentBtnCancel">
                <button onClick={handleClose}>Cancel</button>
              </div>
              <div className="paymentBtnConfirm">
                <button onClick={handleConfirmPayment}>Confirm Payment</button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        {/* cancel order modal  */}
        <Modal
          show={cancelshow}
          onHide={handleCancelClose}
          centered
          className="paymentModal"
        >
          <Modal.Header closeButton style={{ borderBottom: "none" }}>
            {/* <Modal.Title>Cancel Order</Modal.Title> */}
          </Modal.Header>
          <Modal.Body>
            <div className="cancelOrderTitle">
              Are you sure want to cancel order ?
            </div>

            <div className="cancelOrderBtnContainer">
              <div className="paymentBtnCancel">
                <button onClick={handleCancelClose}>Close</button>
              </div>
              <div className="paymentBtnConfirm">
                <button onClick={handleCancelOrder}>Cancel Order</button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};
